// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import WarrantyTypes from '../../warranty-expiration/state/warranty-types';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const WarrantyExpirationTypesCriteria = props => {

    const typesSelectionMessage = props.warrantyTypes.selected.length > 0 ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <div className='warranty-expiration-types-criteria'>
            <CheckboxListWithLabel
                className='warranty-expiration-types'
                initialState={createHashMap(props.warrantyTypes.selected, 'key')}
                isRequired={true}
                label='WARRANTY_TYPES'
                list={addCollectionLabels(props.warrantyTypes.allowed, 'value')}
                onChange={props.onTypeSelectClick}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllTypes}
                type='button'
            >
                <FormattedMessage id={typesSelectionMessage}/>
            </button>
        </div>);

};

WarrantyExpirationTypesCriteria.displayName = 'WarrantyExpirationTypesCriteria';
WarrantyExpirationTypesCriteria.propTypes = {
    onSelectAllTypes: PropTypes.func.isRequired,
    onTypeSelectClick: PropTypes.func.isRequired,
    warrantyTypes: PropTypes.instanceOf(WarrantyTypes).isRequired
};

export default WarrantyExpirationTypesCriteria;




// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/components/warranty-expiration-types-criteria.js